export const EnvironmentDeviceMap = ({
    DesktopWeb : {
        devices:['PC', 'Other']
    },
    MobileWeb : {
        devices:['Mobile Phone', 'Tablet', 'Media Player', 'E-Reader']
    },
    MobileApps : {
        devices:['Mobile Phone', 'Tablet', 'Media Player', 'E-Reader']
    },
    ConnectedTVApp : {
        devices:['TV', 'Set Top Box', 'Games Console']
    }
})
